import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { InformativeModalComponent } from 'src/app/shared/components/informative-modal/informative-modal.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private bsModalService: BsModalService,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return this.handleError(error, req);
      }),
    );
  }

  private handleError(
    error: HttpErrorResponse,
    req: HttpRequest<any>,
  ): Observable<HttpEvent<any>> {
    if (error.status === 401 && !this.isLoginRequest(req)) {
      this.router.navigate(['welcome']);
      this.unathorizedModal();

      return EMPTY;
    }

    return new Observable<HttpEvent<any>>((subscriber) => {
      subscriber.error(error);
    });
  }

  private isLoginRequest(req: HttpRequest<any>): boolean {
    return req.url.includes('/login');
  }

  private unathorizedModal(): void {
    const initialState: ModalOptions = {
      initialState: {
        iconHeader: 'alert-circle.svg',
        subTitle: 'Sesión expirada',
        description:
          'Tu sesión ha expirado por inactividad. Por seguridad, debes iniciar sesión nuevamente para continuar.',
        onlyButtonConfirm: true,
        textButton: 'ACEPTAR',
        visibleButtonClose: false,
      },
      class: 'modal-dialog-centered modal-rounded',
    };

    this.bsModalService.show(InformativeModalComponent, initialState);
  }
}